/* eslint-disable */
import * as types from '../mutation-types';
import apiService from 'src/utils/apiService';

// initial state
const state = {
  platformNotifications: [],
  pendingArchieveConfirmationAlertData: null,
  archivingInProgress: false,
};

// getters
const getters = {
};

// actions
const actions = {
  updatePlatformNotifications({ commit, state, getters }, options = { dontShowErrors: false }) {
    return apiService.getNotifications(options.dontShowErrors).then((data) => {
      commit(types.UPDATE_PLATFORM_NOTIFICATIONS, data);
    });
  },
  closeNotification(s, notification) {
    return apiService.dismissPlatformNotifications([notification.id]);
  },
  closeArrayNotifications(s, notifications) {
    return apiService.dismissPlatformNotifications(notifications);
  },
  closeGroupNotifications(s, group) {
    return apiService.dismissPlatformNotifications(group.notifications.map(p => p.id));
  },
  archieveAlert({ dispatch, state, commit }) {
    if (!state.pendingArchieveConfirmationAlertData) {
      dispatch('closeArchiveNotificationModal');
      return dispatch('closeArchiveNotificationModal');
    }
    commit(types.SET_ARCHIVING_IN_PROGRESS_VALUE, true);
    const { notification, group } = state.pendingArchieveConfirmationAlertData;
    return apiService.archiveAlert(notification.alertID).then(() => {
      const notificationsIdsToDismiss = group.notifications.filter(p => p.alertID === notification.alertID).map(p => p.id);
      return Promise.all([
        dispatch('closeArrayNotifications', notificationsIdsToDismiss).finally(() => {
          return dispatch('updatePlatformNotifications');
        }),
        dispatch('closeArchiveNotificationModal'),
      ]).finally(() => {
        commit(types.SET_ARCHIVE_CONFIRMATION_ALERT_DATA, null);
        commit(types.SET_ARCHIVING_IN_PROGRESS_VALUE, false);
      });
    });
  },
  openArchiveNotificationModal({ commit }, { notification, group }) {
    commit(types.SET_ARCHIVE_CONFIRMATION_ALERT_DATA, { notification, group });
  },
  closeArchiveNotificationModal({ commit }) {
    commit(types.SET_ARCHIVE_CONFIRMATION_ALERT_DATA, null);
  },
};

// mutations
const mutations = {
  [types.UPDATE_PLATFORM_NOTIFICATIONS](s, platformNotifications) {
    s.platformNotifications = platformNotifications || [];
  },
  [types.SET_ARCHIVE_CONFIRMATION_ALERT_DATA](s, data) {
    s.pendingArchieveConfirmationAlertData = data;
  },
  [types.SET_ARCHIVING_IN_PROGRESS_VALUE](s, data) {
    s.archivingInProgress = data;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};



// WEBPACK FOOTER //
// ./src/store/modules/platformNotifications.js